'use client'

import { useEffect } from 'react'
import { PRODUCT_EVENTS } from '@/lib/product-analytics'
import { capturePublicChatEvent } from './funnel-events'

/** Primer paso del funnel (AC2.4): la landing vista, con el consentimiento de la analítica. No pinta nada. */
export function PublicChatLandingViewed({ locale }: { locale: string }) {
  useEffect(() => {
    capturePublicChatEvent(PRODUCT_EVENTS.PUBLIC_CHAT_LANDING_VIEWED, { locale })
  }, [locale])
  return null
}
